import i18next from 'i18next';
import isEmpty from 'lodash/isEmpty';

import { bulkContacts } from 'common/api/v1/contacts';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';
import showToast from 'common/utils/showToast';

import {
    BULK_UPDATE_ITEMS,
    BULK_UPDATE_ITEMS_FAILURE,
    BULK_UPDATE_ITEMS_SUCCESS,
} from '../actionTypes';
import { contactActions } from '../reducer';

import filterContacts from './filterContacts';

export default (ids, value, filterData, callback) => (dispatch) => {
    dispatch(contactActions[BULK_UPDATE_ITEMS]());

    const contacts = ids.map((id) => ({ id, status_flag: value }));

    bulkContacts({ contacts })
        .then((response) => {
            dispatch(contactActions[BULK_UPDATE_ITEMS_SUCCESS](response.data));
            if (!isEmpty(filterData)) dispatch(filterContacts(filterData));
            if (value === 'deleted')
                showToast({ body: i18next.t('It was successfully removed') });
            if (value === 'archived')
                showToast({ body: i18next.t('It was successfully archived') });
            if (value === 'active')
                showToast({
                    body: i18next.t('It was successfully unarchived'),
                });
            if (callback) callback();
        })
        .catch((error) => {
            dispatch(
                contactActions[BULK_UPDATE_ITEMS_FAILURE](
                    error?.response?.data?.errors,
                ),
            );
            showReponseErrorsAsAlert(dispatch, error?.response);
        });
};
